var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"title":_vm.value ? 'Désactiver' : 'Activer',"icon-left":_vm.value ? _vm.iconActivate : _vm.iconDesactivate,"loading":_vm.loading},on:{"click":_vm.onToggle}})}
var staticRenderFns = []

export { render, staticRenderFns }